<template>
  <div class="user_management">
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">ผู้ใช้งาน</div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div>
            <v-btn
              min-width="134"
              height="35"
              color="#5CB844"
              style="border-radius: 25px"
              depressed
              dark
              @click="exportToExcel()"
            >
              <Icon class="font-18" icon="file-icons:microsoft-excel" />
              <span class="ml-2 font-14 font-w-700">Export Excel</span>
            </v-btn>
          </div>
          <div>
            <v-btn
              @click="$router.push({ name: 'UserFormManagement' })"
              width="120px"
              depressed
              rounded
              class="btn_gradient"
            >
              <span class="font-w-700">เพิ่มผู้ใช้งาน</span>
            </v-btn>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="searchData.keyword = $event"
              @onEnter="getUsers()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th width="5%"></th>
            <th width="5%" class="text-center">ลำดับ</th>
            <th width="20%" class="text-left">ชื่อ-สกุล</th>
            <th width="20%" class="text-left">E-Mail</th>
            <th width="15%" class="text-left">สิทธิ์</th>
            <th width="15%" class="text-left">หน่วยงาน</th>
            <th width="10%" class="text-left">โทรศัพท์</th>
            <th width="10%" class="text-center">สถานะ</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in users" :key="i">
            <td class="d-flex align-center">
              <v-btn icon @click="onEdit(item.id)">
                <Icon
                  style="color: #f15a29"
                  class="font-18"
                  icon="bxs:edit-alt"
                />
              </v-btn>
              <v-btn icon @click="onDelete(item.id)">
                <Icon
                  style="color: #b1b1b1"
                  class="font-18"
                  icon="ic:round-delete-forever"
                />
              </v-btn>
            </td>
            <td class="text-center">
              {{ no(i + 1) }}
            </td>
            <td>{{ item.firstname }} {{ item.lastname }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.user_type }}</td>
            <td>
              {{
                item.user_type == "USP"
                  ? item.university?.name_th
                  : item.institute?.name
              }}
            </td>
            <td>{{ item.mobile_phone }}</td>
            <td class="d-flex align-center justify-center">
              <Icon
                v-if="item.status == 1"
                style="color: #5cb844"
                icon="tabler:check"
                class="font-18"
              />
              <span
                :style="
                  item.status == 1 ? { color: '#5CB844' } : { color: '#F9BB43' }
                "
              >
                {{ item.status == 1 ? "อนุมัติ " : "รออนุมัติ" }}
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Paginate -->
    <v-layout mt-4 justify-end class="custom_paginate" v-if="users.length > 0">
      <v-flex shrink>
        <v-pagination
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          :total-visible="7"
          @input="getUsers"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import TextField from "../../../components/input/TextField.vue";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  components: { TextField, Icon },
  name: "UserManagement",
  data() {
    return {
      searchData: {
        keyword: null
      },
      users: [],
      user_all: [],
      paginate: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    async getUsers(page) {
      this.users = [];
      const payload = {
        page: page || 1,
        keyword: this.searchData.keyword,
      };
      let res = await this.$apiFire("Auth/getUsers", payload);
      if (res) {
        this.users = res.users.data;
        this.user_all = res.user_all;
        this.paginate = {
          current_page: res.users.current_page,
          last_page: res.users.last_page,
        };
      }
    },
    onEdit(id) {
      console.log(id);
      this.$router.push({ name: "UserFormEditManagement", params: { id: id } });
    },
    onDelete(id) {
      console.log(id);
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("Auth/delete", id);
          if (res) {
            this.users = this.users.filter((item) => item.id != id);
            this.$store.commit("General/setModal", {
              title: "เสร็จสิ้น!",
              theme: "success",
              text: res,
              showCancel: false,
            });
          }
        },
      });
    },
    no(index) {
      return (this.paginate.current_page - 1) * 10 + index;
    },

    exportToExcel() {
      let data = [];
      this.user_all.forEach((user, i) => {
        data.push({
          ลำดับ: i + 1,
          "ชื่อ - สกุล": user.firstname + " " + user.lastname,
          "E- Mail": user.email,
          สิทธิ์: user.user_type,
          หน่วยงาน:
            user.user_type == "USP"
              ? user.university?.name_th
              : user.institute?.name,
          เบอร์โทรศัพท์: user.mobile_phone,
          สถานะ: user.status == 1 ? "อนุมัติ" : "รออนุมัติ",
        });
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

      let doc_date = moment().add(543, "year").format("DDMMYYYY");
      let fileName = `users_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style lang="scss">
.user_management {
  .btn_gradient {
    background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
    color: #fff !important;
  }

  // adjustment table
  .theme--light.v-data-table {
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px !important;
    .v-data-table__wrapper {
      table {
        thead {
          tr th {
            color: #b1b1b1;
            font-weight: 400;
            font-size: 14px;
          }
          tr:last-child {
            th {
              border-bottom: 1px solid #f15a29 !important;
            }
          }
        }
        tbody {
          tr td {
            font-size: 14px;
            color: #464647;
            font-weight: 400;
          }
          tr:hover {
            background-color: unset !important;
          }
          tr:not(:last-child) {
            td:not(.v-data-table__mobile-row),
            th:not(.v-data-table__mobile-row) {
              border-bottom: 0px solid rgba(0, 0, 0, 0.12) !important;
            }
          }
        }
      }
    }
  }

  // custom paginate
  .custom_paginate {
    .v-pagination__item {
      border-radius: 10px;
      box-shadow: unset !important;
    }
    .v-pagination__navigation {
      border-radius: 10px;
      box-shadow: unset !important;
      background-color: transparent !important;
    }
  }
}
</style>
